import React, { useEffect, useState } from 'react';
import { oneOfType, string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { HomeServices } from './HomeServices';

export const HomeServicesContainer = ({ timeout, ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  }

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="home-services">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <HomeServices {...props} />
    </QueryProvider>
  );
};

HomeServicesContainer.propTypes = {
  timeout: oneOfType([string, number])
};

HomeServicesContainer.defaultProps = {
  timeout: '3000'
};
